import type { StateTree, VAutoItem } from '@makemydeal/dr-dash-types';

export const getVAutoState = (state: StateTree) => {
    return state.vAuto;
};

export const getVAutoItems = (state: StateTree) => {
    const items = getVAutoState(state)?.items as VAutoItem[];
    return items || [];
};

/**
 * True while an appraisal refresh is in flight, which ACV fields use to show a loading indicator.
 * Excludes the fetch on deal load, which would otherwise spin every ACV field on every page load.
 */
export const getIsRefreshingAppraisals = (state: StateTree): boolean => {
    return (getVAutoState(state)?.pendingRefreshCount || 0) > 0;
};

export const getCurrentAppraisalFromVin = (state: StateTree) => {
    const availableAppraisals = [...getVAutoItems(state)];
    availableAppraisals.sort((a, b) => {
        return new Date(b.updatedOn).getTime() - new Date(a.updatedOn).getTime();
    });
    return availableAppraisals[0];
};

export const getCurrentAppraisalId = (state: StateTree) => {
    const currentAppraisal = getCurrentAppraisalFromVin(state);
    return currentAppraisal?.id;
};

export const getCurrentAppraisalByVin = (vin: string) => (state: StateTree) => {
    const availableAppraisals = [...getVAutoItems(state)].filter((appraisal) => appraisal?.vehicle?.vin === vin);
    availableAppraisals.sort((a, b) => {
        return new Date(b.updatedOn).getTime() - new Date(a.updatedOn).getTime();
    });
    return availableAppraisals[0];
};

export const getCurrentAppraisalIdByVin = (vin: string) => (state: StateTree) => {
    const currentAppraisal = getCurrentAppraisalByVin(vin)(state);
    return currentAppraisal?.id;
};
